import React from "react";
const ImageIcon = () => (
    <svg width="65px" height="65px" viewBox="0 0 65 65" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink" style={{ backgroundColor: "white" }}>
        <title>Group 119@0.5x</title>
        <defs>
            <path d="M4,0 L60,0 C62.209139,-4.05812251e-16 64,1.790861 64,4 L64,60 C64,62.209139 62.209139,64 60,64 L4,64 C1.790861,64 2.705415e-16,62.209139 0,60 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z" id="path-1"></path>
        </defs>
        <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
            <g id="Export-PDF-Modal" transform="translate(-688.000000, -494.000000)">
                <g id="Group-120" transform="translate(464.000000, 68.000000)">
                    <g id="Group-77" transform="translate(24.000000, 126.000000)">
                        <g id="01-Components-/-11-Placeholders-/-01-Large-/-01-Image" transform="translate(9.000000, 9.000000)">
                            <g id="Group-119" transform="translate(191.000000, 291.000000)">
                                <g id="base" transform="translate(0.248555, 0.243028)">
                                    <mask id="mask-2" fill="white">
                                        <use xlink-href="#path-1"></use>
                                    </mask>
                                    <use id="Style" fill="#FFFFFF" xlink-href="#path-1"></use>
                                </g>
                                <g id="Group" transform="translate(8.248555, 8.243028)">
                                    <g id="Icon" transform="translate(-0.000000, 0.000000)">
                                        <polygon id="Fill" fill="#E4E4E4" points="16 48 16 40 40 16 48 24 48 48"></polygon>
                                        <path d="M16,32 L32,48 L0,48 L16,32 Z M8,3.63797881e-12 C12.418,3.63797881e-12 16,3.582 16,8 C16,12.418 12.418,16 8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,3.63797881e-12 8,3.63797881e-12 Z" id="Icon-Image-Placeholder" fill="#C7C7C7"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g >
    </svg >
);

export default ImageIcon;